import { Avatar, Flex } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { iColaboradorSquad } from '../../../../../../../../interfaces'
import { StyledContainer, StyledName, StyledText } from './styles'

interface iSquadCardProps {
  colaborador: iColaboradorSquad
  cor: string
  nomeTag: string
}

export const SquadCard: React.FC<iSquadCardProps> = ({ colaborador, cor, nomeTag }) => {
  const nav = useNavigate()
  return (
    <Flex onClick={() => nav(`/Rh/VisualizarPerfil/${colaborador.id}`)} flexDirection={'column'} alignItems={'center'} borderRadius={'.5rem'} padding={'.5rem'} flexDir={'column'} _hover={{ cursor: 'pointer', filter: 'brightness(1.05)', transform: 'translateY(-6px)', transition: '.2s', boxShadow: 'var(--ShadowBtns)' }}>
      <StyledContainer theme={cor}>
        <Avatar src={colaborador.avatar} size={'lg'} marginBottom={'.5rem'} name={colaborador.nome} />
      </StyledContainer>
      <StyledText theme={cor}>{nomeTag}</StyledText>
      <StyledName>{colaborador.nome}</StyledName>
    </Flex>
  )
}
